import React, {Component} from 'react';
import {Helmet} from 'react-helmet';

// Utilities
import stopPropagation from '../utilities/stopPropagation';

// Assets
import TreeArt from '../assets/artwork/TreeArtwork.png';
import BeckyPic from '../assets/teampics/BSHeadshot.png';
import CindyPic from '../assets/teampics/CindyHeadshot.png';
import PJPic from '../assets/teampics/PJHeadshot.png';
import email from '../assets/social/email.svg';
import facebook from '../assets/social/facebook.svg';
import linkedin from '../assets/social/linkedin.svg';
import twitter from '../assets/social/twitter.svg';

// Components
import CtaBtn from '../components/CtaBtn';
import BtnContainer from '../components/BtnContainer';
import Footer from '../components/Footer';
import Modal from '../components/Modal';
import Navbar from '../components/Navbar';
import TeamBoxes from '../components/TeamBoxes';

class About extends Component {

    state = {
        showContent: null,
        showModal: "none",
        displayMobile: "none"
    }

    componentDidMount(){
        window.addEventListener('scroll', this.showStory);
    }

    componentWillUnmount(){
        window.removeEventListener('scroll', this.showStory);
    }

    showStory() {
        const storyContent = document.getElementById("storyContent");
        if (window.scrollY > 400 && storyContent.classList.contains("invisible")){
            storyContent.classList.add("visible");
            storyContent.classList.remove("invisible");
    };}

    resetContent = (e) => {
        const teamContent = document.getElementsByClassName("teamBoxContent");
        let i = teamContent.length;
        while(i--) {
            teamContent[i].classList.add("hide");
        }
    }

    toggleContent = (e) => {
        e.stopPropagation();
        const teamContent = document.getElementsByClassName("teamBoxContent");
        let i = teamContent.length;
        const content = e.target.nextSibling;
        while(i--) {
            if (content.id != i){
                teamContent[i].classList.add("hide");
            }
        }
        content.classList.toggle('hide');
    }

    toggleModal = () => {
        if (this.state.showModal === "none") {
            this.setState({
              showModal: "block"
            })
            window.scrollTo(0,0);
        }
        else {
            this.setState({
              showModal: "none"
            })
        }
      }

      toggleMobileMenu = (e) => {
        e.stopPropagation();
        if (this.state.displayMobile === "none") {
            this.setState({
              displayMobile: "flex"
            })
        }
        else {
            this.setState({
              displayMobile: "none"
            })
        }
      }

    render() {
        return(
            <div className="AboutPage" onClick={this.resetContent}>
            <Helmet>
                <title>About Us | Candid Goat: Tech Solutions for Small Businesses</title>
                <meta name="description" content="Candid Goat was started to help overwhelmed business owners deal with the rapidly growing demands of technology in today's market." />
            </Helmet>
            <Modal showModal={this.state.showModal} click={this.toggleModal} />
            <Navbar click={this.toggleModal} displayMobile={this.state.displayMobile} mobileMenu={this.toggleMobileMenu} />
            <div className="graySlant navbarNeighbor">
                <div className="aboutHeroContainer flexRow container">
                    <div className="aboutHeroContent width-7">
                        <h1 className="titleFont"><strong>Our Vision:</strong> Creating a world where technology serves people</h1>
                        <p className="bodyFont">The rapid growth of technology places enormous pressure on business owners to keep up. Let us take care of that for you, so that when you login and read up, your reports tell a clear story that makes you feel in control of your technology, not the other way around.</p>
                    </div>
                    <div className="aboutHeroImg width-5">
                        <img src={TreeArt} alt="Tech Tree"/>
                    </div>
                </div>
                <div className="teamStory container centerText">
                    <h2 className="titleFont bold">Our Story</h2>
                    <p className="bodyFont width-12 invisible" id="storyContent">We started the Candid Goat as part of our lifelong goal to be good neighbors. For us, being Candid Goat is about building a beautiful neighborhood, both locally and virtually. We recognize the importance of the digital revolution, and we want to make sure we're doing our part to make that revolution a blessing, not a curse. Let us make sure your tech doesn’t consume the time and attention you need to give your business, your friends, and your family.</p>
                </div>
                <div className="container centerText">
                    <h2 className="titleFont bold">Our Team</h2>
                </div>
                <TeamBoxes stopPropagation={stopPropagation} classes="flexColumn width-4" hide="hide" click={this.toggleContent} teamBoxes={[
                    {name: "Becky Sue Wehry", title: "The Boss", profilePic: BeckyPic, social: [{type: "linkedin", img: linkedin, target: "https://www.linkedin.com/in/becky-sue-wehry"}, {type: "email", img: email, target: "mailto:beckysue@candidgoat.com"}],
                    content: "An administrative guru with true grit mentality, Becky Sue has been organizing and running the world since she was fifteen and filling out excel spreadsheets for her dad’s business. She spent the last five years at National Speakers Bureau leaving as the Director Of Operations and Marketing (DOOM) where she bolstered their website traffic by over 500%. She has done freelance UX work for several years and loves to craft a website that caters to the customer.  She brings a serious case of initiative to the table combined with a nasty obsession over customer satisfaction."},
                    {name: "PJ Wehry", title: "The Brains", profilePic: PJPic, social: [{type: "linkedin", img: linkedin, target: "https://www.linkedin.com/in/pj-wehry"}, {type: "email", img: email, target: "mailto:pj@candidgoat.com"}],
                    content: "A self-taught programmer with a master’s degree in philosophy, PJ (affectionately known as Pajamas) is a full-stack JavaScript developer who's also conversant in PHP (Wordpress, Joomla, etc.) and Python (Data Science and Machine Learning). He has big ears that listen well so he can solve your technical problems from search engine results to your backend content management system."},
                    {name: "Cindy Cowherd", title: "The Brawn", profilePic: CindyPic, social: [{type: "email", img: email, target: "mailto:cindy@candidgoat.com"}],
                    content: "A business whiz with a Six Sigma Green Belt, Cindy is the Candid Goat’s secret weapon. Equally at home in the corporate, small business, and nonprofit world, Cindy knows how to provide a clear message that starts first and foremost with your passion. Whether it’s snappy graphics or stellar copy, Cindy knows how to cut fluff and provide meaningful interactions for your customers. She brings the magic moxie that jumpstarts your business’s brand."},]}
                />
            </div>
            <BtnContainer btnType={CtaBtn} click={this.toggleModal} content="We're here to make your life easier." />
            <footer>
                <Footer />
            </footer>
            </div>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/pages/About.js